import { QRCodeCanvas } from "qrcode.react";
import QRCountdown from "./QRValidityPeriod";

export default function QRImage({ qrContent, title, validityPeriod }) {
  const downloadQR = () => {
    const canvas = document.getElementById("qr-canvas").querySelector("canvas");
    const url = canvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.download = `${title}.png`;
    link.href = url;
    link.click();
  };

  return (
    <div className="flex flex-col items-center gap-4">
      <div id="qr-canvas" className="flex flex-col items-center">
        <div className="mb-2 text-xl font-bold text-center">
          Please scan this QRIS to pay
        </div>
        <div
          style={{
            display: "inline-flex",
            padding: 16,
            background: "#fff",
            borderRadius: 12,
            boxShadow: "0 0 40px rgba(201,168,76,0.2)",
          }}
          className="mb-2"
        >
          <QRCodeCanvas
            value={qrContent}
            size={230}
            level="H"
            fgColor="#0a1628"
            bgColor="#ffffff"
          />
        </div>
        <QRCountdown validityPeriod={validityPeriod} />
      </div>
      <button
        onClick={downloadQR}
        className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 transition-colors bg-gray-100 rounded-lg hover:bg-gray-200"
      >
        Download QR
      </button>
    </div>
  );
}
